import { FC } from 'react';
import DropdownTable from '../DropdownTable';
import SimpleFormItem from './subpage/simpleFormItem';
import { getSelectPlaceholder } from '../utils/ruleUtils';
import { DropdownTableProps } from '../DropdownTable/interface';
import {
  BaseSimpleFormProps,
  SimpleFormItemEnum,
} from './interface';

export interface SimpleFormDropdownTableProps extends BaseSimpleFormProps {
  /** dropdownTable Props */
  dropdownTableProps?: DropdownTableProps;
}
/** 下拉表格 */
export const SimpleFormDropdownTable: FC<SimpleFormDropdownTableProps> = props => {
  const {
    dropdownTableProps,
    label,
    rules,
    ...restProps
  } = props;
  return (
    <SimpleFormItem validateTrigger="onChange" label={label} rules={rules} {...restProps}>
      <DropdownTable
        allowClear
        showSearch
        {...dropdownTableProps}
        placeholder={getSelectPlaceholder(label, dropdownTableProps, rules)}
      />
    </SimpleFormItem>
  );
};

SimpleFormDropdownTable.displayName = SimpleFormItemEnum.SimpleFormDropdownTable;

export default SimpleFormDropdownTable;
